import 'slick-carousel';
import 'jquery-zoom';
import 'readmore-js';
import BreakpointsEnum from './enums/breakpointsEnum';
import {moreLink, lessLink} from './components/readmore-link';
import GoodsEnum from './enums/goodsEnum';
import initSlickSliderObserver from './observers/lazyLoading';
import {productsSliderOptions, accessoryCategoriesSliderOptions} from './common/sliderOptions';
import {initReadmoreReviews} from './components/review';
import disabledNextArrow from './common/disabledNextArrow';
import Cart from './common/Cart';

require('./components/product');
require('./components/video');
require('./modals/image-zoom');
require('./components/workload');

let youWatchedSlider = document.getElementById('youWatchedSlider');
let productSimilarSlider = document.getElementById('productSimilarSlider');
let accessoryCategoriesSlider = document.getElementById('accessoryCategoriesSlider');

$(function () {
    let App = window.App;
    App.goods = {};

    let $description = $('.product-description .container-body');
    let $body = $(document.body);

    require('./components/reaction');
    require('./product/fixed-panel');

    if ($('#productVariationsModal').length) {
        require('./modals/product-variations');
    }

    if ($('.product-accessories').length) {
        require('./modals/product-accessories');
    }

    if (!$('.product-slider.empty').length) {
        require('./product/main-slider');
        require('./product/thumbnail-slider');
    }

    if (accessoryCategoriesSlider) {
        disabledNextArrow($(accessoryCategoriesSlider));
    }

    if ($body.data('carrotViewedProduct')) {
        App.analytics.carrotQuestViewedProduct($body.data('carrotViewedProduct'));
    }

    initReadmoreReviews();

    App.goods.changeQuantityInCart = function ($this, productType, productId, sign = undefined) {
        let $parent = $this.parent();
        let $productCount = $parent.find('.product-count');

        let quantity = {
            min: parseInt($parent.data('min')),
            max: parseInt($parent.data('max')),
            new: eval(parseInt($productCount.text()) + sign + 1),
        }

        const delta = quantity.new - parseInt($productCount.text());

        if (quantity.new < quantity.min) {
            $parent.siblings('.to-cart-btn').removeClass('active');
            $('#productMainActionButton').removeClass('active');

            Cart.remove(productType, productId);

            return false;
        } else if (quantity.new > quantity.max) {
            quantity.new = quantity.max;
        }

        $productCount.text(quantity.new);
        $parent.attr('data-maximum-value-reached', Number(quantity.new === quantity.max));

        Cart.change(productType, productId, quantity.new, delta);
    }

    App.goods.addToCart = function (event, $this, type = GoodsEnum.product) {
        if ($this.hasClass('active')) {
            if (window.App.getBreakpoint() == BreakpointsEnum.mobile && $this.closest('.fixed-panel').length) {
                $this.addClass('pending');
            }

            Cart.checkOut($this, $('.js-quantity-products-in-cart').parent().attr('href'));
        } else {
            App.addingToCart.addProduct(event, type, $this, window.App.getBreakpoint() !== BreakpointsEnum.mobile);
        }
    }

    App.goods.addLikeRecommendation = function ($this, recommendation_id) {
        if ($this.hasClass('pending')) {
            return false;
        }
    
        $.ajax({
            type: 'POST',
            url: $this.data('action'),
            data: {
                recommendation_id
            },
            dataType: 'json',
            beforeSend: function () {
                $this.addClass('pending');
            },
            success: function (response) {
                if (response.status == 'OK') {
                    App.analytics.sendAnalyticsGoal('laik');
                    $this.find('.value').text(response.countLikes);
                    $this.closest('.recommendations-container').find('.hint').replaceWith(response.hint_view);
                    $this.addClass('active');
                }
            },
            complete: function () {
                $this.removeClass('pending');
            }
        });
    }

    $('.product-variations .variations').each(function () {
        let $items = $(this).find('.items');
        let height = 40;

        if ($items.hasClass('image-items')) {
            height = 76;
        }

        if ($items.height() > height) {
            $items.css('height', height);
            $items.siblings('button').removeClass('hidden');
        }
    });

    function initDescriptionReadmore() {
        if (window.App.getBreakpoint() === BreakpointsEnum.mobile) {
            $description.readmore({
                collapsedHeight: 388,
                moreLink: moreLink(),
                lessLink: lessLink(),
            });
        }
    }

    initDescriptionReadmore();

    $(document).on('change', '#reviewFilterForm .select-box-input', function (e) {
        e.preventDefault();

        let $form = $(this).closest('form');
        let $reviewsListContainer = $('.reviews-list-container');

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function () {
                $reviewsListContainer.addClass('pending');
            },
            success: function (response) {
                if (response.hasOwnProperty('view')) {
                    $reviewsListContainer.replaceWith(response.view);
                    initReadmoreReviews();
                    window.App.lazyImageLoading();
                }
            },
            complete: function () {
                $reviewsListContainer.removeClass('pending');
            }
        });
    });

    $(document).on('click', '#accessoriesPagination button, .product-accessories .categories-list a', function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.hasClass('is-loading')) {
            return false;
        }

        let isNextPage = $(e.currentTarget).is(":button");
        let url = isNextPage ? $this.attr('data-next-page') : $this.attr('href');
        let $pagination = $('#accessoriesPagination');
        let $modelsList = $('.product-accessories .products-container');

        $this.closest('.categories-list').find('a').removeClass('active');
        $this.addClass('active');

        $.ajax({
            type: 'POST',
            url: url,
            dataType: 'json',
            beforeSend: function () {
                if (isNextPage) {
                    $this.addClass('is-loading');
                } else {
                    $modelsList.addClass('pending');
                }
            },
            success: function (response) {
                if (response.pagination_view) {
                    if ($pagination.length) {
                        $pagination.replaceWith(response.pagination_view);
                    } else {
                        $('.product-accessories .container-body').append(response.pagination_view);
                    }
                } else {
                    $pagination.remove();
                }

                if (response.models_view) {
                    if (isNextPage) {
                        $modelsList.append(response.models_view);
                    } else {
                        $modelsList.html(response.models_view);

                        let countModels = $modelsList.children().length;

                        $('#showMoreAccessoriesToggle').prop('checked', false);
                        $('.product-accessories .container-body > label').attr('data-count-models', countModels);
                    }
                }

                App.analytics.sendAnalyticsGoal('menu akssesuarov');
                window.App.lazyImageLoading();
            },
            complete: function () {
                if (isNextPage) {
                    $this.removeClass('is-loading');
                } else {
                    $modelsList.removeClass('pending');
                }
            }
        });
    });
    
    $(window).resize(function () {
        if (window.App.getBreakpoint() !== BreakpointsEnum.mobile && $description.attr('data-readmore') !== undefined) {
            $description.readmore('destroy');
        } else if ($description.attr('data-readmore') === undefined) {
            initDescriptionReadmore();
        }
    });
});

$(window).on('load resize', () => {
    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        initSlickSliderObserver(youWatchedSlider, productsSliderOptions);
        initSlickSliderObserver(productSimilarSlider, productsSliderOptions);
    }

    if (accessoryCategoriesSlider && window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
        initSlickSliderObserver(accessoryCategoriesSlider, accessoryCategoriesSliderOptions);
    }
});